import { render, staticRenderFns } from "./AbTest.vue?vue&type=template&id=2116eede&"
import script from "./AbTest.vue?vue&type=script&lang=ts&"
export * from "./AbTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports